<template>
  <transition name="modal" v-if="showModal">
    <div class="modal-mask">
      <div :class="{ 'modal-container': true, small: true }">
        <div class="modal-header">
          <slot name="header">
            <p class="title is-3" v-text="title"></p>
          </slot>
        </div>

        <div class="modal-body">
          <slot></slot>
        </div>

        <div class="modal-footer">
          <a
            type="submit"
            class="button is-danger is-medium"
            @click="submit"
            :disabled="loading"
          >
            Confirm
            <div v-if="loading" class="centered loader is-medium"></div>
          </a>

          <a
            class="button cancel-button is-medium"
            @click="hide"
            :disabled="loading"
            >Cancel</a
          >
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: null,
    },

    title: {
      type: String,
      default: 'Danger',
    },
  },

  data() {
    return {
      showModal: false,
      loading: false,
    };
  },

  watch: {
    showModal(showModal) {
      if (showModal) {
        this.$emit('shown');
      } else {
        this.$emit('hidden');
      }
    },
  },

  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    toggle() {
      this.showModal = !this.showModal;
    },

    async submit() {
      try {
        this.loading = true;
        let { data } = await axios.delete(this.url);
        this.$emit('success', data);
      } catch (errors) {
        this.$emit('error');
        console.error(errors);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" projectd>
@import 'node_modules/bulma/sass/utilities/_all';

.modal-mask {
  position: fixed;
  z-index: 999998;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.modal-container {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  transform: none;

  @include desktop {
    min-width: 1200px;

    &.small {
      min-width: 600px;
    }
  }
  @include widescreen {
    min-width: 1400px;

    &.small {
      min-width: 800px;
    }
  }
}

.modal-header {
  padding: 20px;
  background-color: #e92a3d;

  p.title {
    color: $white;
  }
}

.modal-body {
  padding: 20px;
  overflow-y: scroll;
}

.modal-footer {
  padding: 20px;
  background: #ecf0f2;
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.5s;

  .modal-container {
    transition: transform 0.5s;
  }
}

.modal-enter,
.modal-leave-to {
  opacity: 0;

  .modal-container {
    transform: scale(0.8);
  }
}
</style>
